/**
 * StatusBadge.jsx — AIRGROW Material Interface
 * アイコン付きステータスピルバッジ
 *
 * variant:
 *   primary   — C.primaryContainer / C.onPrimary  （件数・ステータスなど）
 *   secondary — C.secondaryContainer / C.secondary（連携済み・有効・認証済みなど）
 *   error     — C.errorContainer / C.onErrorContainer（未連携・エラーなど）
 *   neutral   — C.surfaceContainer / C.onSurfaceVariant（無効・要認証・グループ名など）
 *
 * 使い方:
 *   <StatusBadge icon="check_circle" variant="secondary">連携済み</StatusBadge>
 *   <StatusBadge variant="neutral">要認証</StatusBadge>
 *   <StatusBadge variant="primary" style={{ marginLeft: 12 }}>3件</StatusBadge>
 */
import React from 'react';
import { C } from '../../ColorTokens';

const VARIANTS = {
  primary:   { bg: C.primaryContainer,   color: C.onPrimary },
  secondary: { bg: C.secondaryContainer, color: C.secondary },
  error:     { bg: C.errorContainer,     color: C.onErrorContainer },
  neutral:   { bg: C.surfaceContainer,   color: C.onSurfaceVariant },
};

export default function StatusBadge({ icon, variant = 'secondary', children, style: extraStyle }) {
  const cfg = VARIANTS[variant] || VARIANTS.secondary;
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        padding: '2px 10px',
        borderRadius: 9999,
        background: cfg.bg,
        color: cfg.color,
        fontSize: 12,
        fontWeight: 600,
        fontFamily: "'Space Grotesk', sans-serif",
        letterSpacing: '0.3px',
        ...extraStyle,
      }}
    >
      {icon && (
        <span
          className="material-symbols-outlined"
          style={{ fontSize: 14, fontVariationSettings: "'FILL' 1" }}
        >
          {icon}
        </span>
      )}
      {children}
    </span>
  );
}
